import React from 'react';
import type { RouteProps } from 'react-router-dom';
import { Redirect, Route } from 'react-router-dom';
import { Loader } from '../components';
import { useImplementationPlanEnabled } from '../hooks/useSchoolInfo';
import { ROUTES } from '../util/vars';

interface ImplementationPlanRouteProps extends RouteProps {
  children: React.ReactNode;
}

// Schools in countries without the implementation plan are sent home, as they are by the api.
export const ImplementationPlanRoute = ({ children, ...rest }: ImplementationPlanRouteProps): JSX.Element => {
  const { isEnabled, isLoading } = useImplementationPlanEnabled();

  return (
    <Route {...rest} render={() => {
      if (isLoading) {
        return <Loader />;
      }

      return isEnabled ? children : <Redirect to={ROUTES.home} />;
    }} />
  );
};
